import {
  COMPANY_NOTIFICATION,
  ADD_COMPANY,
  DELETE_COMPANY,
  UPDATE_COMPANY,
  GET_COMPANY,
} from "../actions/types";

const initialState = {
  companies: [],
  companyNotification: "",
};

export default function (state = initialState, action) {
  let companies = state.companies;
  switch (action.type) {
    case COMPANY_NOTIFICATION:
      return {
        ...state,
        companyNotification: action.payload,
      };
    case GET_COMPANY:
      if (action.payload.length === 1) {
        let fInd = companies.findIndex((x) => x.id === action.payload[0].id);
        if (fInd > -1) {
          companies[fInd] = action.payload[0];
        } else {
          companies.push(action.payload[0]);
        }
      } else {
        companies = action.payload;
      }

      return {
        ...state,
        companies,
      };

    case UPDATE_COMPANY:
      if (action.payload.length === 1) {
        let fInd = companies.findIndex((x) => x.id === action.payload[0].id);
        if (fInd > -1) {
          companies[fInd] = action.payload[0];
        } else {
          companies.push(action.payload[0]);
        }
      }
      return {
        ...state,
        companies,
      };

    case DELETE_COMPANY:
      return {
        ...state,
        companies: action.payload,
      };

    case ADD_COMPANY:
      let fInd1 = companies.findIndex((x) => x.id === action.payload[0].id);
      if (fInd1 > -1) {
        companies[fInd1] = action.payload[0];
      } else {
        companies.push(action.payload[0]);
      }
      return {
        ...state,
        companies,
      };

    default:
      return state;
  }
}
